(() => {
  const menuRoot = document.querySelector('full-menu');
  if (!menuRoot) return;

  const topItems = Array.from(menuRoot.querySelectorAll(':scope > ul > li'));
  const topTriggers = topItems
    .map((li) => li.querySelector(':scope > a, :scope > megamenu-departments > .linklist > a'))
    .filter(Boolean);

  let lastOpened = null;

  const isHandled = (li) =>
    li.classList.contains('menu-item-has-children') || li.classList.contains('menu-item-has-megamenu');

  const closeAll = () => {
    menuRoot.querySelectorAll('li.showmenu').forEach((li) => {
      li.classList.remove('showmenu');
      const t = li.querySelector(':scope > a, :scope > megamenu-departments > .linklist > a');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    lastOpened = null;
  };

  const openItem = (li, trigger) => {
    closeAll();
    li.classList.add('showmenu');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    lastOpened = trigger;
  };

  const submenuLinks = (li) =>
    Array.from(li.querySelectorAll(':scope > .sub-menu a, :scope > .sub-menu button, :scope .mega-menu-container a, :scope .mega-menu-container button'))
      .filter((el) => !el.closest('[hidden]') && el.offsetParent !== null);

  topTriggers.forEach((trigger, idx) => {
    const li = trigger.closest('li');
    if (!li || !isHandled(li)) return;

    trigger.addEventListener('keydown', (e) => {
      const k = e.key;

      if (k === ' ' || k === 'Enter') {
        e.preventDefault();
        if (li.classList.contains('showmenu')) closeAll();
        else openItem(li, trigger);
        return;
      }

      if (k === 'Escape') {
        if (li.classList.contains('showmenu')) {
          closeAll();
          trigger.focus();
        }
        return;
      }

      if (k === 'ArrowDown') {
        e.preventDefault();
        if (!li.classList.contains('showmenu')) openItem(li, trigger);
        const links = submenuLinks(li);
        if (links.length) links[0].focus();
        return;
      }

      if (k === 'ArrowUp') {
        e.preventDefault();
        if (!li.classList.contains('showmenu')) openItem(li, trigger);
        const links = submenuLinks(li);
        if (links.length) links[links.length - 1].focus();
        return;
      }

      if (k === 'ArrowRight') {
        e.preventDefault();
        const next = topTriggers[(idx + 1) % topTriggers.length];
        if (next) next.focus();
        return;
      }

      if (k === 'ArrowLeft') {
        e.preventDefault();
        const prev = topTriggers[(idx - 1 + topTriggers.length) % topTriggers.length];
        if (prev) prev.focus();
        return;
      }

      if (k === 'Home') {
        e.preventDefault();
        topTriggers[0].focus();
        return;
      }

      if (k === 'End') {
        e.preventDefault();
        topTriggers[topTriggers.length - 1].focus();
        return;
      }
    });
  });

  menuRoot.addEventListener('keydown', (e) => {
    const k = e.key;
    if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'Escape' && k !== 'Tab') return;

    const openLi = menuRoot.querySelector('li.showmenu');
    if (!openLi) return;

    if (k === 'Escape') {
      const trigger = openLi.querySelector(':scope > a, :scope > megamenu-departments > .linklist > a');
      closeAll();
      if (trigger) trigger.focus();
      return;
    }

    const active = document.activeElement;
    if (!openLi.contains(active) || active === openLi.querySelector(':scope > a, :scope > megamenu-departments > .linklist > a')) {
      return;
    }

    const links = submenuLinks(openLi);
    if (!links.length) return;
    const i = links.indexOf(active);
    if (i < 0) return;

    if (k === 'ArrowDown') {
      e.preventDefault();
      links[(i + 1) % links.length].focus();
    } else if (k === 'ArrowUp') {
      e.preventDefault();
      links[(i - 1 + links.length) % links.length].focus();
    }
  });

  menuRoot.addEventListener('focusout', (e) => {
    if (!menuRoot.contains(e.relatedTarget)) closeAll();
  });

  document.addEventListener('click', (e) => {
    if (!menuRoot.contains(e.target)) closeAll();
  });
})();
